import numeral from 'numeral'

export function formatNumber(n: number) {
  return numeral(n).format('0[.]0a')
}

export function formatCurrency(n: number) {
  return numeral(n).format('$0[.]0a')
}
